var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.switchTheme()}}},[(!_vm.isDark)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" fas fa-sun ")]):_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" fas fa-moon ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }